import { Link } from "react-router-dom";

interface ContentBlockProps {
  content: string;
}

const renderTextWithLinks = (text: string) => {
  const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const parts: (string | JSX.Element)[] = [];
  let lastIndex = 0;
  let match;

  while ((match = markdownLinkRegex.exec(text)) !== null) {
    const [fullMatch, label, url] = match;

    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const isInternal = url.startsWith('/') && !url.startsWith('//');

    if (isInternal) {
      parts.push(
        <Link
          key={match.index}
          to={url}
          className="text-blue-400 hover:text-blue-300 hover:underline underline-offset-2"
        >
          {label}
        </Link>
      );
    } else {
      parts.push(
        <a
          key={match.index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 hover:underline underline-offset-2"
        >
          {label}
        </a>
      );
    }

    lastIndex = match.index + fullMatch.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};

const ContentBlock = ({ content }: ContentBlockProps) => {
  return (
    <p className="text-gray-300 leading-relaxed mb-8 text-lg">
      {renderTextWithLinks(content)}
    </p>
  );
};

export default ContentBlock;
